<template>
    <v-container fluid class="" style="margin-top: 60px">
        <!--<div id="cargando"
             wire:loading
             class="
                fixed
                top-0
                left-0
                right-0
                bottom-0
                w-full
                h-screen
                z-50
                overflow-hidden
                bg-gray-700
                opacity-75
                flex flex-col
                items-center
                justify-center">
            <div class="
                    loader
                    ease-linear
                    rounded-full
                    border-4 border-t-4
                    h-12
                    w-12
                    mb-4">
            </div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>-->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64">

            </v-progress-circular>
        </v-overlay>
        <div>
            <v-item-group>
                <v-container>
                    <v-row>
                        <v-col cols="12" v-if="this.busqueda.aseguradora != ''"
                               sm="4"
                               md="2" style="padding: 5px 5px 5px 5px !important;">
                            <v-list v-if="this.busqueda.aseguradora != ''" :class="'defaultConst--text font-weight-bold'" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important; ">
                                <v-list-item v-for="item in this.busqueda.aseguradora" style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{ item.clnombre }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col v-if="this.busqueda.flotilla != ''"
                               cols="12"
                               sm="4"
                               md="2" style="padding: 5px 5px 5px 5px !important;">

                            <v-list v-if="this.busqueda.flotilla != ''" :class="'defaultConst--text font-weight-bold'" color="primary" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important;">
                                <v-list-item style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{this.busqueda.flotilla.flnomcorto}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>

                        <v-col v-if="this.busqueda.estado != '' && this.busqueda.estado !=null"
                               cols="12"
                               sm="4"
                               md="2" style="padding: 5px 5px 5px 5px !important;">
                            <v-list v-if="this.busqueda.estado != ''" :class="'defaultConst--text font-weight-bold'" color="blue-grey-lighten-3" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important;">
                                <v-list-item style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{this.busqueda.estado.esnombre}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col v-if="this.busqueda.gerencia != '' && this.busqueda.gerencia !=null"
                               cols="12"
                               sm="3"
                               md="2" style="padding: 5px 5px 5px 5px !important;">
                            <v-list v-if="this.busqueda.gerencia != ''" :class="'defaultConst--text font-weight-bold'" color="blue-grey-lighten-3" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important;">
                                <v-list-item style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{this.busqueda.gerencia.genombre}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>

                        <v-col v-if="this.busqueda.supervisoria != '' && this.busqueda.supervisoria !=null"
                               cols="12"
                               sm="4"
                               md="2" style="padding: 5px 5px 5px 5px !important;">
                            <v-list v-if="this.busqueda.supervisoria != ''" :class="'defaultConst--text font-weight-bold'" color="blue-grey-lighten-3" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important;">
                                <v-list-item style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{this.busqueda.supervisoria.sunombre}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col v-if="this.busqueda.abogado != '' && this.busqueda.abogado !=null"
                               cols="12"
                               sm="5"
                               md="3" style="padding: 5px 5px 5px 5px !important;">
                            <v-list v-if="this.busqueda.abogado != ''" :class="'defaultConst--text font-weight-bold'" color="blue-grey-lighten-3" style="border-radius: 5% 5% 5%; background-color: #B0BEC5 !important;">
                                <v-list-item style="min-height: 15px !important;">
                                    <v-list-item-title style="font-size: 12px; color: black">{{this.busqueda.abogado.prnombre}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>

                </v-container>
            </v-item-group>

        </div>
        <Sidebar :validaFilter="validaFilter" :validaHelp="validaHelp" />
        <div v-if="permiso">
            <Dashboard :dataTurnadoColision="dataTurnadoColision"
                       :dataTurnadoRobo="dataTurnadoRobo"
                       :dataPendientesColision="dataPendientesColision"
                       :dataPendientesRobo="dataPendientesRobo"
                       :dataVhDetenidos="dataVhDetenidos"
                       :dataRLV="dataRLV"
                       :filtro="busquedaTablero" />
        </div>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import dash from '@/services/Dashboard/Dashboard.service.js';
    import Dashboard from '@/components/pages/main/Dashboard/Dashboard.vue';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Sidebar from '@/components/pages/operacion/tableroDB/SidebarDB.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Dashboard,
            Sidebar
        },
        data() {
            return {
                validaFilter: true,
                validaHelp: false,
                busqueda: {
                    todo: false,
                    proceso: '',
                    aseguradora: '',
                    flotilla: '',
                    estado: '',
                    gerencia: '',
                    supervisoria: '',
                    abogado: '',
                    relevancia: '',
                    perfil: '',
                    seccion: ''
                },
                dataTurnadoColision: [],
                dataTurnadoRobo: [],
                dataPendientesColision: [],
                dataPendientesRobo: [],
                dataVhDetenidos: [],
                dataRLV:[],
                showcargando: true,
                permiso: false,
                overlay: false,
            };
        },
        watch: {
            'key.tablero': function (newVal, oldVal) {
                this.overlay = true;
                this.busqueda = this.busquedaTablero;
                this.verificandoBusqueda(true);
                this.nuevaPeticion = this.verificarBusqueda;
                this.BusquedaFiltro(this.busquedaTablero);
            },

        },
        methods: {
            ...mapMutations('Operacion', ['asignarBusqueda', 'cambiarKey', 'verificandoBusqueda']),

            async BusquedaFiltro(filtro) {
                var formData = new FormData();

                formData.append("data", JSON.stringify([filtro]));
                await dash.ObtenerTurnadoColisiones(this, formData).then(data => {
                    this.dataTurnadoColision = data[0];
                    dash.ObtenerTurnadoRobos(this, formData).then(data => {
                        this.dataTurnadoRobo = data[0];
                        dash.ObtenerPendientesColisiones(this, formData).then(data => {
                            this.dataPendientesColision = data[0];
                            dash.ObtenerPendientesRobos(this, formData).then(data => {
                                this.dataPendientesRobo = data[0];
                                dash.ObtenerVhDetenidos(this, formData).then(data => {
                                    this.dataVhDetenidos = data[0];
                                    dash.ObtenerRLV(this, formData).then(data => {
                                    this.dataRLV = data[0];
                                    this.permiso = true;
                                    this.overlay = false;
                                });
                                   
                                });
                            });
                        });
                    });
                });
            }
        },

        computed: {
            ...mapState(["domain", "theme"]),
            ...mapState('Operacion', ['busquedaTablero', 'key', 'verificarBusqueda']),
        },
        async mounted() {

            this.overlay = true;
            if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {

                this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                await this.BusquedaFiltro(this.busqueda);
            }
            else {
                await dash.DashboardPerfil(this).then(data => {
                    this.busqueda.perfil = data[0].perfil;
                    this.busqueda.seccion = '';
                    if (data[0].geclave != '0' && data[0].geclave != 0)
                        this.busqueda.gerencia = { geclave: data[0].geclave, genombre: data[0].genombre };
                    if (data[0].suclave != '0' && data[0].suclave != 0)
                        this.busqueda.supervisoria = { suclave: data[0].suclave, sunombre: data[0].sunombre };
                    if (data[0].perfil == 'A')
                        this.busqueda.abogado = { prclave: data[0].valor, prnombre: data[0].prnombre };
                });
                await MetodosGenerales.guardarEnSesionInfoReporte(this.busqueda, "BusquedaFiltrox");
                await this.BusquedaFiltro(this.busqueda);
            }


        }

    };
</script>